import React from "react";
import { useNavigate } from "react-router-dom";
import { clearToken } from "../utils/auth";
import { FaGift, FaTicketAlt, FaSignOutAlt } from "react-icons/fa";
import TopBar from "../components/TopBar";
import BottomBar from "../components/BottomBar";

const MenuPage = () => {
  const navigate = useNavigate();

  const logout = () => {
    clearToken();
    navigate("/");
  };

  return (
    <div className="flex flex-col min-h-screen">
        <TopBar />

        <div className="flex flex-col items-center justify-center flex-1 p-4 bg-gray-100">
            <h1 className="text-2xl font-bold mb-8">เลือกเมนู</h1>

            <button
                className="bg-green-500 text-white text-2xl p-4 rounded w-full max-w-xs mb-4 grid items-center justify-center gap-2"
                onClick={() => navigate("/give-point")}
            >
                <FaGift className="text-8xl" />
                ให้พอยท์
            </button>

            <button
                className="bg-yellow-500 text-white text-2xl p-4 rounded w-full max-w-xs mb-8 grid items-center justify-center gap-2"
                onClick={() => navigate("/coupon")}
            >
                <FaTicketAlt className="text-8xl" />
                ใช้คูปอง
            </button>

            <button
                className="text-red-500 underline flex items-center gap-1"
                onClick={logout}
            >
                <FaSignOutAlt />
                Logout
            </button>
        </div>

        <BottomBar />
    </div>
  );
};

export default MenuPage;
